import type {
  PlayerPackProjectionsColumns,
  PlayerPacksColumns
} from '@library/types/playerPacks/playerPacks';
import type { TableColumn } from '@library/types/utils';

export const PLAYER_PACKS_TABLE_HEADER: Array<TableColumn<PlayerPacksColumns>> =
  [
    {
      column: 'id',
      essential: true,
      label: 'ID',
      sortEnabled: false, // TODO: add sorting
      width: 'w-[10%] px-3'
    },
    {
      column: 'title',
      essential: true,
      label: 'Title',
      sortEnabled: false, // TODO: add sorting
      width: 'w-2/5 px-3'
    },
    {
      column: 'place_by_time',
      essential: true,
      label: 'Place By',
      sortEnabled: false, // TODO: add sorting
      width: 'w-1/5 px-3'
    },
    {
      column: 'created_at',
      essential: true,
      label: 'Created At',
      sortEnabled: false, // TODO: add sorting
      width: 'w-1/5 px-3'
    },
    {
      column: 'can_fade',
      essential: true,
      label: 'Can Fade',
      sortEnabled: false, // TODO: add sorting
      width: 'w-1/5 px-3'
    }
  ];

export const PLAYER_PACK_PROJECTIONS_TABLE_HEADER: Array<
  TableColumn<PlayerPackProjectionsColumns>
> = [
  {
    column: 'player',
    essential: true,
    label: 'Player',
    sortEnabled: false,
    width: 'w-1/4 px-3'
  },
  {
    column: 'projection',
    essential: true,
    label: 'Projection',
    sortEnabled: false,
    width: 'w-1/4 px-3'
  },
  {
    column: 'stat_type',
    essential: true,
    label: 'Stat type',
    sortEnabled: false,
    width: 'w-1/4 px-3'
  },
  {
    column: 'prop',
    essential: true,
    label: 'Prop',
    sortEnabled: false,
    width: 'w-1/4 px-3'
  }
];
